import React, { FC, useContext, useEffect }         from 'react';
import { useUIDisplayModes, useWindowMeasurements } from '../../hooks';
import { DynamicComponentsContext }                 from '../contexts';
import { SidebarComponent, SidebarComponentProps }  from './SidebarComponent';


type PageSidebarProps = Omit<SidebarComponentProps, 'sidebar'>;

const PageSidebar: FC<PageSidebarProps> = ( props ) => {

    let { sidebar }                                     = useContext( DynamicComponentsContext ),
        { minimizedChrome }                             = useUIDisplayModes(),
        { getSidebarTopOffset, getSidebarBottomOffset } = useWindowMeasurements();

    useEffect( () => {

        // console.log( {
        // 	    minimizedChrome,
        // 	    offsetTop:    getSidebarTopOffset(),
        // 	    offsetBottom: getSidebarBottomOffset(),
        // } )

    }, [ minimizedChrome ] )

    return (
        <SidebarComponent
            sidebar={ sidebar }
            offsetTop={ getSidebarTopOffset() }
            offsetBottom={ getSidebarBottomOffset() }
            { ...props }
        />
    )
};

export { PageSidebar }
